<template>
    <!-- 门票  -->
    <div class="lmy-ticket">
    	<!-- <header class="lmy-header lmy-header-w" >
	      <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
	      门票
	    </header> -->
	    <div class="lmy-filter-container-a" style="margin-top: .3rem;">
            <div class="lmy-new-search">
                <i class="iconfont icon-yuyin" onclick="window.history.go(-1)" style="line-height: .7rem;background-color: #f8f8f8; border-radius: 5px;"></i>
                <div class="city-box" @click="cityData.show=true">
                  {{CityName}}
                </div>
                <div class="search-box">
                    <div class="input-box">
                        <input type="text" v-model="ticketName" placeholder="请输入搜索关键字">
                    </div>
                    <span class="search-btn" @click="changeFilter"><i class="iconfont icon-search"></i></span>
                </div>
            </div>
            <div class="lmy-flash lmy-flash-div">
                <div class="flash-content" v-for="tk in ticketList" @click="toDetail(tk)">
                    <div class="flash-figure">
                        <!-- <p>龙猫门票</p> -->
                        <img class="product-img" :src="tk.ListImg|replaceImgSrc(4)" v-if="tk.ListImg&&tk.ListImg!='/'" alt="" >
                        <img class="product-img" src="./../../assets/img/hotelDetailsDf.png" v-else alt="" >
                    </div>
                    <div class="flash-sum-a">
                        <div class="info holidayInfo">
                            <p>{{tk.ProductName}}</p>
                            <div class="ticket-price" v-show="tk.Price"><span class="money">￥{{tk.Price}}</span> 起</div>
                        </div>
                  </div>
                </div>
            </div>
	        <!-- <div class="title">
	          <h4 >热门景点</h4>
	        </div> -->
            <!-- <div class="list-item" v-for="tk in ticketList" @click="toTicketDetails(tk)">
                <img :src="tk.Pic|replaceImgSrc(8)" v-if="tk.Pic&&tk.Pic!='/'" alt="" class="lmy-tk-img">
                <img src="./../../assets/img/default-hotel.jpg" v-else alt="" class="lmy-tk-img">
                <div class="lmy-tk-info">
                    <div class="lmyti-text">
                        <h4>{{tk.ScenicName}}</h4>
                        <div class="lmyti-off-box">
                            <span class="lmyti-off-btn" v-for="item in tk.ScenicThemes">{{item.Name}}</span>
                        </div>
                        <div class="lmyti-city" v-if="tk.Distance">据您6.8公里</div>
                        <div class="lmyti-city">
                            <span>{{tk.CityName}}</span>
                            <label v-if="tk.ScenicLevel">{{tk.ScenicLevel}}A景区</label>
                        </div>
                    </div>
                    <div class="lmyti-price" v-if="tk.LowestPrice">
                        <span>￥</span>
                        <label>{{tk.LowestPrice}}</label>
                        <span>起</span>
                    </div>
                </div>
            </div> -->
      	</div>
	    <infinite-loading @infinite="initData" ref="infiniteLoading">
		    <div slot="no-more" class="line-package" >
	        	<span>我们是有底线的</span>
	    	</div>
	    	<span slot="no-results" >
		     	暂时没有相关产品...
		    </span>
	    </infinite-loading>
        <transition  name="slide" >
            <City @select="cityData.select" @reSetLocation="cityData.reSetLocation" :cityData="cityData"  v-show="cityData.show" ></City>
        </transition>
    </div>
</template>
<script>
    import City from '../common/cmpnt/city.vue'//城市选择器
    import InfiniteLoading from 'vue-infinite-loading';
	export default{
		name:'ticket-list',
	    components:{
	      	InfiniteLoading,
            City,
	    },
	    data(){
		    return{
		        ticketList:[],
		        Page:1,
		        PageSize:10,
		        total:0,
		        ticketName:'',
                CityID:'',
                CityName:'',
                cityData:{
                    show:false,
                    from:1,
                    myCityName:this.dao.get('MyCityName')?this.dao.get('MyCityName'):'',
                    MyCityRegionID:this.dao.get('MyCityID')?this.dao.get('MyCityID'):'',
                    select:(city,from)=>{
                        this.cityData.show=false;
                        this.CityID = city.I || city.ID || this.CityID;
                        this.CityName = city.S || city.SName || this.CityName;
      
                    },
                    reSetLocation:()=>{
                        this.cityData.show=false;
                        this.CityName = this.dao.get('MyCityName')?this.dao.get('MyCityName'):'',
                        this.CityID = this.dao.get('MyCityID')?this.dao.get('MyCityID'):''
                    }
                },
		    }
        },
        mounted(){
            this.CityID = this.$route.query.CityID||this.dao.get("MyCityID")
            this.CityName = this.$route.query.CityName||this.dao.get('MyCityName')
            this.ticketName = this.$route.query.key||''
            this.changeFilter()
        },
	    methods:{
            toDetail(item){
                this.$router.push('/ticketDetails?ProductID='+item.ProductID+'&SupFlag='+item.SupFlag);
            },
	    	changeFilter($state) {
	 			this.Page=1;
	 			this.total=0;
				this.ticketList=[]; 
		      	this.$nextTick(() => {
		      	    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		      	});
		    }, 
	    	//获取门票列表
            initData($state){
            	if(this.total>0&&(((this.Page-1)*this.PageSize)>this.total)){
		          	$state.complete();
		          	return;
		        }
                var that=this;
                var params={
                    Page:that.Page,
                    PageSize:that.PageSize,
                    Name:that.ticketName,
                    CityID:that.CityID,
                    Type:1,
                }
                that.postRequest({
                    url: that.Api.getOnlineList,
                    params: params
                }).then(res => {
                    if (res&&res.IsSuccess&&res.Result.length>0) {
                        that.total=res.Total;
                        that.Page++;
                        that.ticketList=that.ticketList.concat(res.Result);
            			$state.loaded();
                    } else {
                         $state.complete();
                    }
                });
            },
            //查询门票价格
            getTicketRange(list,callback){
                var that = this;
                var params = {
                    ScenicIDs:that.getScenicIdArr(list),
                    CheckIn: this.getDate(0),
                }
                that.postRequest({
                    url: that.Api.getScenicPriceRange,
                    params: params
                }).then(res => {
                    if (res&&res.IsSuccess) {
                        var rgList=that.concatTicketList(list,res.Result);
                        
                        callback(rgList);
                    }
                });
            },
            getScenicIdArr(list){
                var arr = [];
                for(let i = 0; i < list.length; i++){
                    arr.push(list[i].ScenicId)
                }
                return arr
            },
             //整合数据 
            concatTicketList(TicketsList,ScenicIdsList){
                var that=this;
                for(let i = 0; i < TicketsList.length; i++){
                    for(let j = 0; j < ScenicIdsList.length; j++){
                        if(TicketsList[i].ScenicId == ScenicIdsList[j].ScenitID){
                            TicketsList[i]['Min'] = ScenicIdsList[j].Min;
                            TicketsList[i]['Max'] = ScenicIdsList[j].Max;
                        }
                    }
                }
                return TicketsList
            },
	    }

	}
</script>



// WEBPACK FOOTER //
// src/components/ticket/list.vue